var FakeCation = window.FakeCation || {};

(function (fc) {
  "use strict";

  const NAME = 'share';
  const FINAL = 'canvas_share';
  const DOWNLOAD = 'download_button';
  const FB_SHARE = 'facebook_button';
  const REDIRECT_TO = '/fb_share';
  var pageManager = fc.pageManager;
  var fb = fc.fb;
  var needLogin = true;

  var currentPage = pageManager.Page.create(NAME, '/' + NAME, '#' + NAME);

  currentPage.html = `<h1><img src="/assets/app/logo.svg" id="logo"></h1><div class="content"><div class="middle"><canvas id="${FINAL}"></canvas></div></div><footer class=""><a href="/backgrounds" class="button"><img src="/assets/app/xbutton.svg"></a><a id="${DOWNLOAD}" class="button" download="selfiehop.jpg"><img src="/assets/app/downloadbutton.svg"></a><span id="${FB_SHARE}" class="button hidden"><img src="/assets/app/facebookbutton.svg"></span></footer>`;

  currentPage.eventHandlers = [
    {
      event: 'click',
      target: '#' + FB_SHARE,
      handler: function () {
        fc.ga('/share_pic_'+fc.appState.bgUrl);
        if (needLogin) {
          fb.login({
            scope: 'user_photos,publish_actions',
            return_scopes: true
          }).then(function (response) {
            fc.appState.accessToken = response.authResponse.accessToken;
            currentPage.redirect(REDIRECT_TO);
          });
        } else {
          currentPage.redirect(REDIRECT_TO);
        }
      }
    },
    {
      event: 'click',
      target: '#' + DOWNLOAD,
      handler: function () {
        fc.ga('/save_pic_'+fc.appState.bgUrl);
      }
    }
  ];

  currentPage.run = function () {
    var canvas = this.$$('#' + FINAL),
        ctx = canvas.getContext('2d'),
        final = fc.appState.final,
        downloadAnchor = this.$$('#' + DOWNLOAD);

    var showFacebook = function() {
      var fbutton = this.$$('#' + FB_SHARE);

      console.log(`need login: ${needLogin}`);
      fbutton.classList.remove('hidden');
    }.bind(this);

    canvas.width = final.width;
    canvas.height = final.height;
    ctx.putImageData(final, 0, 0);

    canvas.toBlob(function (blob) {
      fc.appState.finalBlob = blob;
      downloadAnchor.href = URL.createObjectURL(blob);
    }, 'image/jpeg', 0.8);

    fb.getLoginStatus().then(function (response) {
      needLogin = false;
      fc.appState.accessToken = response.authResponse.accessToken;
      showFacebook();
    }).catch(function () {
      needLogin = true;
      showFacebook();
    });

  };

  pageManager.add(currentPage);

}(FakeCation));
